<template>
  <div class="login-container">
    <div id="myBox">
      <div class="left">
        <!-- <p>辽宁省沈抚改革创新示范区</p>
        <p>智慧招商平台</p> -->
        <img
          class="leftName"
          src="@/assets/login/name.png"
          alt="辽宁省沈抚改革创新示范区智慧招商平台"
        />
      </div>
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        auto-complete="on"
        label-position="top"
      >
        <div class="title-container">
          <h3 class="title"><span>登录</span><i></i></h3>
        </div>

        <el-form-item prop="username" label="用户名">
          <el-input
            ref="username"
            v-model="loginForm.username"
            placeholder="请输入用户名"
            name="username"
            type="text"
            tabindex="1"
            auto-complete="on"
          />
        </el-form-item>

        <el-form-item prop="password" label="密码">
          <el-input
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="请输入密码"
            name="password"
            tabindex="2"
            auto-complete="on"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon
              :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"
            />
          </span>
        </el-form-item>
        <el-form-item label="验证码:" prop="code" class="custom-code-content">
          <el-input
            class="custom-code-input"
            v-model="loginForm.code"
            placeholder="请输入验证码"
          ></el-input>
          <el-button
            class="custom-code-login"
            type="primary"
            :disabled="!codeState || timeInterval ? true : false"
            :class="[!codeState || timeInterval ? 'customDisabled' : '']"
            @click="mobileClick"
          >
            {{ obtainCode }}
          </el-button>
        </el-form-item>

        <el-button
          type="primary"
          style=""
          @click.native.prevent="handleLogin"
          class="btnMy"
          >登录</el-button
        >
        <el-button type="primary" style="" class="btnMy e" @click="registJump"
          >注册</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
import { setToken } from "@/utils/auth.js";
import { getLogin } from "@/api/public.js";
import { getPhoneCode } from "@/api/app";
// import $ from "jquery";
export default {
  name: "Login",
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value.trim()) {
        callback(new Error("用户名不能为空"));
      } else {
        this.codeState = true;
        callback();
      }
      // if (!validUsername(value)) {
      //   callback(new Error("Please enter the correct user name"));
      // } else {
      //   callback();
      // }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      codeState: false,
      time_s: 60,
      timeInterval: null,
      obtainCode: "获取验证码",
      passVisible: false,
      phoneVisible: false,
      loginForm: {
        username: "",
        password: "",
        code: ""
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername }
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword }
        ],
        code: [{ required: true, trigger: "blur", message: "请输入验证码" }]
      },
      loading: false,
      passwordType: "password",
      redirect: undefined
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    async mobileClick() {
      let phoneCode = /^1[3456789]\d{9}$/;
      if (!phoneCode.test(this.loginForm.username)) {
        this.$message.error("请输入正确手机号");
      } else {
        await getPhoneCode({
          phoneNumber: this.loginForm.username,
          templateId: "SMS_247795134"
        });
        this.timeInterval = setInterval(() => {
          this.obtainCode = this.time_s + "S后重试";
          this.time_s--;
          if (this.time_s < 0) {
            clearInterval(this.timeInterval);
            this.timeInterval = null;
            this.time_s = 60;
            this.obtainCode = "获取验证码";
          }
        }, 1000);
      }
    },
    registJump() {
      this.$router.push({
        path: "/register"
      });
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      let _this = this;
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          _this.loading = true;
          getLogin(this.loginForm).then(res => {
            _this.loading = false;
            if (res.success) {
              setToken(res.data.token);
              _this.$router.push({ path: "/" });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

@bg: #283443;
@light_gray: rgba(85, 85, 85, 1);
@cursor: rgba(85, 85, 85, 1);

@supports (-webkit-mask: none) and (not (cater-color: @cursor)) {
  .login-container .el-input input {
    color: @cursor;
    font-size: 16px;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    // height: 47px;
    width: 0;
    flex: 1;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: @light_gray !important;
      caret-color: @cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px transparent inset !important;
      }
    }
  }
  .btnMy {
    width: 100%;
    height: 57px;
    background: #187cf7;
    border-radius: 4px;
    font-size: 20px;
    margin-bottom: 20px;
    margin-top: 20px;
    color: #fff;
    &.e {
      background: transparent;
      color: #187cf7;
      border: 1px solid #187cf7;
      margin-left: 0;
      margin-top: 8px;
      margin-bottom: 0;
    }
  }
  .el-form-item {
    border-bottom: 1px solid #dbe6f6;
    box-sizing: border-box;
    // overflow: hidden;
    margin-bottom: 20px;
  }
  .el-form-item__content {
    line-height: inherit;
    box-sizing: border-box;
    // overflow: hidden;
    display: flex;
    align-items: center;
  }
}
</style>

<style lang="less" scoped>
@bg: #2d3a4b;
@dark_gray: #889aa4;
@light_gray: #eee;
@font_size: 40px;
.login-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("../../assets/login/bg0.png") no-repeat;
  background-size: cover;
  background-position: center center;
  overflow: hidden;
  color: rgba(85, 85, 85, 1);
  > div {
    width: 78.13vmax;
    // height: 40vmax;
    // width: 1114px;
    // height: 768px;
    min-width: 860px;
    min-height: 545px;
    display: flex;
    justify-content: space-between;
    & > .left {
      width: 44.6%;
      padding-top: 20px;
      // height: 100%;
      // padding: 60px 0;
      // padding-left: 50px;
      color: #fff;
      font-family: zhenyan;
      font-size: @font_size;
      text-shadow: 0px 1px 8px rgba(27, 38, 106, 0.74);
      p {
        margin: 0;
      }
      & > .leftName {
        width: 100%;
      }
    }
    > .login-form {
      width: 38.67%;
      min-width: 300px;
      padding: 53px 64px 70px;
      overflow: hidden;
      background-color: #fff;
      // background: #ffffff;
      display: flex;
      flex-direction: column;
      // justify-content: space-around;
      .el-form-item {
        padding-left: 11px;
        border: 0;
        /deep/ .el-form-item__content {
          border-bottom: 1px solid #e9e9e9;
          input {
            padding: 0;
            font-size: 22px;
          }
        }
        &:nth-child(4) {
          /deep/ .el-form-item__content {
            border-bottom: 0;
            display: flex;
            align-items: flex-end;
            .el-input {
              border-bottom: 1px solid #e9e9e9;
              margin-right: 40px;
            }
          }
        }
      }
      /deep/.el-form-item__label {
        font-size: @font_size / 2;
        color: #333;
        font-weight: normal;
        &::before {
          display: none;
        }
      }
    }
  }

  .tips {
    font-size: 1rem;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 0.5rem 0.5rem 0.5rem 1rem;
    color: #409eff;
    vertical-align: middle;
    // width: 2rem;
    display: inline-block;
    .svg-icon {
      width: 1.3em;
      height: 1.3em;
      font-size: 1.3rem;
    }
  }

  .title-container {
    position: relative;

    .title {
      font-size: @font_size;
      color: #252d3b;
      // color: rgba(85, 85, 85, 1);
      // margin: 0px auto 40px auto;
      // text-align: center;
      font-weight: 500;
      margin-top: 0;
      margin-bottom: 56px;
      i {
        display: inline-block;
        width: 26px;
        height: 26px;
        background: url("../../assets/login/icon.png") no-repeat;
        background-size: 100% 100%;
        margin-left: 20px;
      }
    }
  }

  .show-pwd {
    // position: absolute;
    // right: 10px;
    // top: 7px;
    font-size: 16px;
    color: @dark_gray;
    cursor: pointer;
    user-select: none;
    margin-right: 15px;
  }
}
@media screen and (max-width: 1610px) {
  .login-container > div > .login-form {
    padding: 40px 60px;
  }
  .login-container .btnMy {
    height: 45px;
  }
  .login-container > div > .left p,
  .login-container .title-container .title {
    font-size: 30px;
  }
  .login-container .title-container .title {
    margin-bottom: 40px;
  }
  .login-container > div {
    // min-width: 790px;
    min-width: 1032px;
  }
}
</style>
